import { lazy } from 'react'

export const UsagePurposeVariant1 = lazy(() => import('./UsagePurposeVariant1'))
export const UsagePurposeVariant2 = lazy(() => import('./UsagePurposeVariant2'))
